"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegExp = escapeRegExp;
exports.dimensionValueToString = dimensionValueToString;
exports.removeLeadingSlashFromPath = removeLeadingSlashFromPath;
exports.addLeadingSlashToPath = addLeadingSlashToPath;
exports.capitalizeString = void 0;

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function dimensionValueToString(value) {
  return value ? value.toString() : '0';
}

function removeLeadingSlashFromPath(str) {
  if (str.indexOf('/') === 0) {
    return str !== '/' ? str.substr(1) : null;
  }

  return str;
}

function addLeadingSlashToPath(str) {
  if (str.indexOf('/') !== 0) {
    return "/" + str;
  }

  return str;
}

var capitalizeString = function capitalizeString(str) {
  if (typeof str !== 'string') {
    return undefined;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
};

exports.capitalizeString = capitalizeString;